import {ILanguageTokens} from "./localization/LanguageTokens";
import {IProjectPage} from "./interfaces/components/pages/projects/IProjectPage";
import {ICareerSection} from "./types/ICareerProject";

export const APP_TOKEN = 'HOMEPAGE_TF_';
export const alertDurationInMs = 4000;
// EmailJs
export const emailJsServiceId = "tfehrmann_homepage_id";
export const emailJsTemplateId = "template_rsbrpnm";
export const emailJsPublicKey = "4vyO9frZ9NBbIyt2U";

// Required. Default URL-endpoint is https://ik.imagekit.io/your_imagekit_id
export const IK_CONTEXT_URL_ENDPOINT = 'https://ik.imagekit.io/timfehrmann/homepage/';


export const PERSONAL_PROJECTS = (languageTokens: ILanguageTokens): IProjectPage[] => {
    return [
        // boxOfCards V3
        {
            mediaCardElement: {
                thumbnail: 'projects/web/boxofcards/v3/01_landingpage.jpg',
                description: languageTokens.boxOfCardsV3Description,
                name: languageTokens.boxOfCardsV3Name,
                subHeader: languageTokens.boxOfCardsV3SubHeader,
                route: 'boxofcardsv3',
            },
            sections: [
                {
                    image: 'projects/web/boxofcards/v3/01_landingpage.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_01,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_01,
                    description: languageTokens.boxOfCardsV3SectionDescription_01,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/02_menu.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_02,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_02,
                    description: languageTokens.boxOfCardsV3SectionDescription_02,
                    size: {
                        width: 500,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/03_gamelobby_deck_selection.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_03,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_03,
                    description: languageTokens.boxOfCardsV3SectionDescription_03,
                    size: {
                        width: 500,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/04_gamelobby_option_selection.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_04,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_04,
                    description: languageTokens.boxOfCardsV3SectionDescription_04,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/05_gamelobby_add_players.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_05,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_05,
                    description: languageTokens.boxOfCardsV3SectionDescription_05,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/06_gameboard_sentence_selection.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_06,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_06,
                    description: languageTokens.boxOfCardsV3SectionDescription_06,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/07_gameboard_answers_selection.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_07,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_07,
                    description: languageTokens.boxOfCardsV3SectionDescription_07,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/08_gameboard_answers_presentation.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_08,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_08,
                    description: languageTokens.boxOfCardsV3SectionDescription_08,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/09_gameboard_winner.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_09,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_09,
                    description: languageTokens.boxOfCardsV3SectionDescription_09,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/10_gameboard_history.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_10,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_10,
                    description: languageTokens.boxOfCardsV3SectionDescription_10,
                    size: {
                        width: 200,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/11_gameboard_answers_selection_light_and_german.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_11,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_11,
                    description: languageTokens.boxOfCardsV3SectionDescription_11,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/12_choose_deck_overview.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_12,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_12,
                    description: languageTokens.boxOfCardsV3SectionDescription_12,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/13_deck_editing_larger_screen.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_13,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_13,
                    description: languageTokens.boxOfCardsV3SectionDescription_13,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/14_deck_editing_info.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_14,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_14,
                    description: languageTokens.boxOfCardsV3SectionDescription_14,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/15_downloaded_deck.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_15,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_15,
                    description: languageTokens.boxOfCardsV3SectionDescription_15,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/16_discord_login.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_16,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_16,
                    description: languageTokens.boxOfCardsV3SectionDescription_16,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/17_discord_server.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_17,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_17,
                    description: languageTokens.boxOfCardsV3SectionDescription_17,
                    size: {
                        width: 250,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/18_faq.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_18,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_18,
                    description: languageTokens.boxOfCardsV3SectionDescription_18,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/19_legal_stuff.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_19,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_19,
                    description: languageTokens.boxOfCardsV3SectionDescription_19,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/20_aws_costs.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_20,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_20,
                    description: languageTokens.boxOfCardsV3SectionDescription_20,
                    size: {
                        width: 300,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/21_aws_factory.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_21,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_21,
                    description: languageTokens.boxOfCardsV3SectionDescription_21,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/22_aws_bugs.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_22,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_22,
                    description: languageTokens.boxOfCardsV3SectionDescription_22,
                    size: {
                        width: 350,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/23_appsync_websockets.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_23,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_23,
                    description: languageTokens.boxOfCardsV3SectionDescription_23,
                    size: {
                        width: 500,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/24_aws_bugs_2.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_24,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_24,
                    description: languageTokens.boxOfCardsV3SectionDescription_24,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/25_rewrite_code.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_25,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_25,
                    description: languageTokens.boxOfCardsV3SectionDescription_25,
                    size: {
                        width: 350,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/26_dedicated_instances.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_26,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_26,
                    description: languageTokens.boxOfCardsV3SectionDescription_26,
                    size: {
                        width: 350,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/27_caching.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_27,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_27,
                    description: languageTokens.boxOfCardsV3SectionDescription_27,
                    size: {
                        width: 300,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/28_aws_to_digital_ocean.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_28,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_28,
                    description: languageTokens.boxOfCardsV3SectionDescription_28,
                    size: {
                        width: 300,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/29_boxofcards_v3_frontend.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_29,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_29,
                    description: languageTokens.boxOfCardsV3SectionDescription_29,
                    size: {
                        width: 500,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/30_boxofcards_v3_webclient_deployment.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_30,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_30,
                    description: languageTokens.boxOfCardsV3SectionDescription_30,
                    size: {
                        width: 500,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/31_boxofcards_v3_node.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_31,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_31,
                    description: languageTokens.boxOfCardsV3SectionDescription_31,
                    size: {
                        width: 500,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/32_boxofcards_v3_components.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_32,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_32,
                    description: languageTokens.boxOfCardsV3SectionDescription_32,
                    size: {
                        width: 900,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/33_tests.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_33,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_33,
                    description: languageTokens.boxOfCardsV3SectionDescription_33,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/34_axios.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_34,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_34,
                    description: languageTokens.boxOfCardsV3SectionDescription_34,
                    size: {
                        width: 500,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v3/35_react_router_prompts.jpg',
                    imageName: languageTokens.boxOfCardsV3SectionImageDescription_35,
                    descriptionHeader: languageTokens.boxOfCardsV3SectionHeader_35,
                    description: languageTokens.boxOfCardsV3SectionDescription_35,
                    size: {
                        width: 350,
                    }
                },
            ],
            previous:
                {
                    name: `${languageTokens.To} V2`,
                    route: "boxofcardsv2",
                },
            links: [
                {
                    prefix: "",
                    name: "boxof.cards",
                    address: "https://boxof.cards",
                },
            ],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Ts-cluster
        {
            mediaCardElement: {
                thumbnail: 'projects/ts-cluster/ts_cluster_thumbnail_00.png',
                description: languageTokens.tsClusterDescription,
                name: languageTokens.tsClusterName,
                subHeader: languageTokens.tsClusterSubHeader,
                route: 'tscluster',
            },
            sections: [
                {
                    image: 'projects/ts-cluster/01_techstack.jpg',
                    imageName: languageTokens.tsClusterSectionImageDescription_01,
                    descriptionHeader: languageTokens.tsClusterSectionHeader_01,
                    description: languageTokens.tsClusterSectionDescription_01,
                },
                {
                    image: 'projects/ts-cluster/02_components.jpg',
                    imageName: languageTokens.tsClusterSectionImageDescription_02,
                    descriptionHeader: languageTokens.tsClusterSectionHeader_02,
                    description: languageTokens.tsClusterSectionDescription_02,
                },
                {
                    image: 'projects/ts-cluster/03_directories.png',
                    imageName: languageTokens.tsClusterSectionImageDescription_03,
                    descriptionHeader: languageTokens.tsClusterSectionHeader_03,
                    description: languageTokens.tsClusterSectionDescription_03,
                },
                {
                    image: 'projects/ts-cluster/04_container-registry.png',
                    imageName: languageTokens.tsClusterSectionImageDescription_04,
                    descriptionHeader: languageTokens.tsClusterSectionHeader_04,
                    description: languageTokens.tsClusterSectionDescription_04,
                },
                {
                    image: 'projects/ts-cluster/05_droplet-snapshots.png',
                    imageName: languageTokens.tsClusterSectionImageDescription_05,
                    descriptionHeader: languageTokens.tsClusterSectionHeader_05,
                    description: languageTokens.tsClusterSectionDescription_05,
                },
                {
                    image: 'projects/ts-cluster/06_aws-domains.png',
                    imageName: languageTokens.tsClusterSectionImageDescription_06,
                    descriptionHeader: languageTokens.tsClusterSectionHeader_06,
                    description: languageTokens.tsClusterSectionDescription_06,
                },
                {
                    image: 'projects/ts-cluster/07_tests.jpg',
                    imageName: languageTokens.tsClusterSectionImageDescription_07,
                    descriptionHeader: languageTokens.tsClusterSectionHeader_07,
                    description: languageTokens.tsClusterSectionDescription_07,
                },
                {
                    image: 'projects/ts-cluster/08_digital-ocean_test-nodes.png',
                    imageName: languageTokens.tsClusterSectionImageDescription_08,
                    descriptionHeader: languageTokens.tsClusterSectionHeader_08,
                    description: languageTokens.tsClusterSectionDescription_08,
                },
                {
                    descriptionHeader: languageTokens.tsClusterSectionHeader_09,
                    description: languageTokens.tsClusterSectionDescription_09,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // boxOfCards V2
        {
            mediaCardElement: {
                thumbnail: 'projects/web/boxofcards/v2/01_landingPage.png',
                description: languageTokens.boxOfCardsV2Description,
                name: languageTokens.boxOfCardsV2Name,
                subHeader: languageTokens.boxOfCardsV2SubHeader,
                route: 'boxofcardsv2',
            },
            sections: [
                {
                    image: 'projects/web/boxofcards/v2/01_landingPage.png',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_01,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_01,
                    description: languageTokens.boxOfCardsV2SectionDescription_01,
                },
                {
                    image: 'projects/web/boxofcards/v2/02_cardTutorial.png',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_02,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_02,
                    description: languageTokens.boxOfCardsV2SectionDescription_02,
                },
                {
                    image: 'projects/web/boxofcards/v2/03_techstack.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_03,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_03,
                    description: languageTokens.boxOfCardsV2SectionDescription_03,
                },
                {
                    image: 'projects/web/boxofcards/v2/04_components.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_04,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_04,
                    description: languageTokens.boxOfCardsV2SectionDescription_04,
                },
                {
                    image: 'projects/web/boxofcards/v2/05_refactor.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_05,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_05,
                    description: languageTokens.boxOfCardsV2SectionDescription_05,
                },
                {
                    image: 'projects/web/boxofcards/v2/06_refactor1.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_06,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_06,
                    description: languageTokens.boxOfCardsV2SectionDescription_06,
                    size: {
                        width: 800,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v2/07_refactor2.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_07,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_07,
                    description: languageTokens.boxOfCardsV2SectionDescription_07,
                    size: {
                        width: 800,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v2/08_responsiveness.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_08,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_08,
                    description: languageTokens.boxOfCardsV2SectionDescription_08,
                },
                {
                    image: 'projects/web/boxofcards/v2/09_cleaner.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_09,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_09,
                    description: languageTokens.boxOfCardsV2SectionDescription_09,
                    size: {
                        width: 800,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v2/10_responsive_cards.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_10,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_10,
                    description: languageTokens.boxOfCardsV2SectionDescription_10,
                    size: {
                        width: 800,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v2/11_responsive_board.gif',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_11,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_11,
                    description: languageTokens.boxOfCardsV2SectionDescription_11,
                },
                {
                    image: 'projects/web/boxofcards/v2/12_avatars.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_12,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_12,
                    description: languageTokens.boxOfCardsV2SectionDescription_12,
                },
                {
                    image: 'projects/web/boxofcards/v2/13_darkmode.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_13,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_13,
                    description: languageTokens.boxOfCardsV2SectionDescription_13,
                },
                {
                    image: 'projects/web/boxofcards/v2/14_deployment.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_14,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_14,
                    description: languageTokens.boxOfCardsV2SectionDescription_14,
                },
                {
                    image: 'projects/web/boxofcards/v2/15_concurrency.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_15,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_15,
                    description: languageTokens.boxOfCardsV2SectionDescription_15,
                },
                {
                    image: 'projects/web/boxofcards/v2/16_tests.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_16,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_16,
                    description: languageTokens.boxOfCardsV2SectionDescription_16,
                    size: {
                        width: 700,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v2/17_bug.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_17,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_17,
                    description: languageTokens.boxOfCardsV2SectionDescription_17,
                },
                {
                    image: 'projects/web/boxofcards/v2/18_tests.jpg',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_18,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_18,
                    description: languageTokens.boxOfCardsV2SectionDescription_18,
                },
                {
                    image: 'projects/web/boxofcards/v2/19_aws_cloudformation.png',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_19,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_19,
                    description: languageTokens.boxOfCardsV2SectionDescription_19,
                },
                {
                    image: 'projects/web/boxofcards/v2/20_aws_dynamodb.png',
                    imageName: languageTokens.boxOfCardsV2SectionImageDescription_20,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_20,
                    description: languageTokens.boxOfCardsV2SectionDescription_20,
                },
                {
                    // image: 'projects/web/boxofcards/v2/21TODO',
                    // imageName: languageTokens.boxOfCardsV2SectionImageDescription_21,
                    descriptionHeader: languageTokens.boxOfCardsV2SectionHeader_21,
                    description: languageTokens.boxOfCardsV2SectionDescription_21,
                },
            ],
            previous:
                {
                    name: `${languageTokens.To} V1`,
                    route: "boxofcardsv1",
                },
            next:
                {
                    name: `${languageTokens.To} V3`,
                    route: "boxofcardsv3",
                },
            links: [
                {
                    prefix: "",
                    name: "boxof.cards",
                    address: "https://boxof.cards",
                },
            ],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // LampClock
        {
            mediaCardElement: {
                thumbnail: 'projects/lamp/lampclock/1_lampclock_finalBack.jpg',
                description: languageTokens.lampClockDescription,
                name: languageTokens.lampClockName,
                subHeader: languageTokens.lampClockSubHeader,
                route: 'lampClock',
            },
            sections: [
                {
                    image: 'projects/lamp/lampclock/1_lampclock_finalBack.jpg',
                    imageName: languageTokens.lampClockImageDescription_01,
                    descriptionHeader: languageTokens.lampClockSectionHeader_01,
                    description: languageTokens.lampClockSectionDescription_01,
                },
                {
                    image: 'projects/lamp/lampclock/2_lampclock_disc.jpg',
                    imageName: languageTokens.lampClockImageDescription_02,
                    descriptionHeader: languageTokens.lampClockSectionHeader_02,
                    description: languageTokens.lampClockSectionDescription_02,
                    size: {
                        width: 500,

                    }
                },
                {
                    image: 'projects/lamp/lampclock/3_lampclock_cut.jpg',
                    imageName: languageTokens.lampClockImageDescription_03,
                    descriptionHeader: languageTokens.lampClockSectionHeader_03,
                    description: languageTokens.lampClockSectionDescription_03,
                },
                {
                    image: 'projects/lamp/lampclock/4_lampclock_coloring.jpg',
                    imageName: languageTokens.lampClockImageDescription_04,
                    descriptionHeader: languageTokens.lampClockSectionHeader_04,
                    description: languageTokens.lampClockSectionDescription_04,
                },
                {
                    image: 'projects/lamp/lampclock/5_lampclock_cabling.jpg',
                    imageName: languageTokens.lampClockImageDescription_05,
                    descriptionHeader: languageTokens.lampClockSectionHeader_05,
                    description: languageTokens.lampClockSectionDescription_05,
                },
                {
                    image: 'projects/lamp/lampclock/6_lampclock_powerSupply.jpg',
                    imageName: languageTokens.lampClockImageDescription_06,
                    descriptionHeader: languageTokens.lampClockSectionHeader_06,
                    description: languageTokens.lampClockSectionDescription_06,
                },
                {
                    image: 'projects/lamp/lampclock/7_lampclock_ledSetup.png',
                    imageName: languageTokens.lampClockImageDescription_07,
                    descriptionHeader: languageTokens.lampClockSectionHeader_07,
                    description: languageTokens.lampClockSectionDescription_07,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: 'projects/lamp/lampclock/8_lampclock_solderStation.jpg',
                    imageName: languageTokens.lampClockImageDescription_08,
                    descriptionHeader: languageTokens.lampClockSectionHeader_08,
                    description: languageTokens.lampClockSectionDescription_08,
                    size: {
                        width: 500,

                    }
                },
                {
                    image: 'projects/lamp/lampclock/9_lampclock_ledSoldering.jpg',
                    imageName: languageTokens.lampClockImageDescription_09,
                    descriptionHeader: languageTokens.lampClockSectionHeader_09,
                    description: languageTokens.lampClockSectionDescription_09,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/lamp/lampclock/10_lampclock_components.png',
                    imageName: languageTokens.lampClockImageDescription_10,
                    descriptionHeader: languageTokens.lampClockSectionHeader_10,
                    description: languageTokens.lampClockSectionDescription_10,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: 'projects/lamp/lampclock/11_lampclock_weather_lambda.png',
                    imageName: languageTokens.lampClockImageDescription_11,
                    descriptionHeader: languageTokens.lampClockSectionHeader_11,
                    description: languageTokens.lampClockSectionDescription_11,
                },
                {
                    image: 'projects/lamp/lampclock/12_lampclock_ledModeConfig.png',
                    imageName: languageTokens.lampClockImageDescription_12,
                    descriptionHeader: languageTokens.lampClockSectionHeader_12,
                    description: languageTokens.lampClockSectionDescription_12,
                    size: {
                        width: 500,
                    }
                },
                {
                    image: 'projects/lamp/lampclock/13_lampclock_init.png',
                    imageName: languageTokens.lampClockImageDescription_13,
                    descriptionHeader: languageTokens.lampClockSectionHeader_13,
                    description: languageTokens.lampClockSectionDescription_13,
                },
                {
                    image: 'projects/lamp/lampclock/14_lampclock_weather_mapping.png',
                    imageName: languageTokens.lampClockImageDescription_14,
                    descriptionHeader: languageTokens.lampClockSectionHeader_14,
                    description: languageTokens.lampClockSectionDescription_14,
                    size: {
                        width: 500,
                    }
                },
                {
                    image: 'projects/lamp/lampclock/15_lampclock_platformIni.png',
                    imageName: languageTokens.lampClockImageDescription_15,
                    descriptionHeader: languageTokens.lampClockSectionHeader_15,
                    description: languageTokens.lampClockSectionDescription_15,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/lamp/lampclock/16_lampclock_finalOff.jpg',
                    imageName: languageTokens.lampClockImageDescription_16,
                    descriptionHeader: languageTokens.lampClockSectionHeader_16,
                    description: languageTokens.lampClockSectionDescription_16,
                },
                {
                    image: 'projects/lamp/lampclock/17_lampclock_finalOn.jpg',
                    imageName: languageTokens.lampClockImageDescription_17,
                    descriptionHeader: languageTokens.lampClockSectionHeader_17,
                    description: languageTokens.lampClockSectionDescription_17,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // boxOfCards V1
        {
            mediaCardElement: {
                thumbnail: 'projects/web/boxofcards/v1/webapp/01_landingPage.jpg',
                description: languageTokens.boxOfCardsV1Description,
                name: languageTokens.boxOfCardsV1Name,
                subHeader: languageTokens.boxOfCardsV1SubHeader,
                route: 'boxofcardsv1',
            },
            sections: [
                {
                    image: 'projects/web/boxofcards/v1/webapp/01_landingPage.jpg',
                    imageName: languageTokens.boxOfCardsV1LandingPageImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1WebappSectionHeader_01,
                    description: languageTokens.boxOfCardsV1WebappSectionDescription_01,
                },
                {
                    image: 'projects/web/boxofcards/v1/webapp/02_deckSelection.png',
                    imageName: languageTokens.boxOfCardsV1DeckSelectionImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1WebappSectionHeader_02,
                    description: languageTokens.boxOfCardsV1WebappSectionDescription_02,
                },
                {
                    image: 'projects/web/boxofcards/v1/webapp/03_deckEditor.png',
                    imageName: languageTokens.boxOfCardsV1DeckEditorImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1WebappSectionHeader_03,
                    description: languageTokens.boxOfCardsV1WebappSectionDescription_03,
                },
                {
                    image: 'projects/web/boxofcards/v1/webapp/04_multiplayerlobby.png',
                    imageName: languageTokens.boxOfCardsV1MultiplayerLobbyImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1WebappSectionHeader_04,
                    description: languageTokens.boxOfCardsV1WebappSectionDescription_04,
                },
                {
                    image: 'projects/web/boxofcards/v1/webapp/05_gamelobby.png',
                    imageName: languageTokens.boxOfCardsV1GameLobbyImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1WebappSectionHeader_05,
                    description: languageTokens.boxOfCardsV1WebappSectionDescription_05,
                },
                {
                    image: 'projects/web/boxofcards/v1/webapp/06_game.png',
                    imageName: languageTokens.boxOfCardsV1WebAppImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1WebappSectionHeader_06,
                    description: languageTokens.boxOfCardsV1WebappSectionDescription_06,
                },
                // Architecture
                {
                    descriptionHeader: languageTokens.boxOfCardsV1ArchitectureSectionHeader_00,
                    description: languageTokens.boxOfCardsV1ArchitectureSectionDescription_00,
                },
                {
                    image: 'projects/web/boxofcards/v1/architecture/01_componentsAll.png',
                    imageName: languageTokens.boxOfCardsV1ComponentsAllImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ArchitectureSectionHeader_01,
                    description: languageTokens.boxOfCardsV1ArchitectureSectionDescription_01,
                },
                {
                    image: 'projects/web/boxofcards/v1/architecture/02_componentWebApp.png',
                    imageName: languageTokens.boxOfCardsV1ComponentWebAppImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ArchitectureSectionHeader_02,
                    description: languageTokens.boxOfCardsV1ArchitectureSectionDescription_02,
                    size: {
                        width: 300,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v1/architecture/03_componentsBackend.png',
                    imageName: languageTokens.boxOfCardsV1ComponentBackendWebAppImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ArchitectureSectionHeader_03,
                    description: languageTokens.boxOfCardsV1ArchitectureSectionDescription_03,
                    size: {
                        width: 800,
                    }
                },
                {
                    image: 'projects/web/boxofcards/v1/architecture/04_componentRedis.png',
                    imageName: languageTokens.boxOfCardsV1ComponentRedisImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ArchitectureSectionHeader_04,
                    description: languageTokens.boxOfCardsV1ArchitectureSectionDescription_04,
                    size: {
                        width: 500,

                    }
                },
                {
                    image: 'projects/web/boxofcards/v1/architecture/05_componentRabbitMq.png',
                    imageName: languageTokens.boxOfCardsV1ComponentRabbitMqDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ArchitectureSectionHeader_05,
                    description: languageTokens.boxOfCardsV1ArchitectureSectionDescription_05,
                    size: {
                        width: 400,

                    }
                },
                {
                    image: 'projects/web/boxofcards/v1/architecture/06_componentGoogleCloud.png',
                    imageName: languageTokens.boxOfCardsV1ComponentGoogleCloudImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ArchitectureSectionHeader_06,
                    description: languageTokens.boxOfCardsV1ArchitectureSectionDescription_06,
                    size: {
                        width: 400,

                    }
                },
                {
                    image: 'projects/web/boxofcards/v1/architecture/07_kubectlGetAll.png',
                    imageName: languageTokens.boxOfCardsV1ComponentKubeCtlGetAllImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ArchitectureSectionHeader_07,
                    description: languageTokens.boxOfCardsV1ArchitectureSectionDescription_07,
                },
                {
                    image: 'projects/web/boxofcards/v1/architecture/08_digitalOceanKubernetes.png',
                    imageName: languageTokens.boxOfCardsV1ComponentDigitalOceanKubernetesImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ArchitectureSectionHeader_08,
                    description: languageTokens.boxOfCardsV1ArchitectureSectionDescription_08,
                },
                // TechStack
                {
                    descriptionHeader: languageTokens.boxOfCardsV1TechStackSectionHeader_00,
                    description: languageTokens.boxOfCardsV1TechStackSectionDescription_00,
                },
                {
                    image: 'projects/web/boxofcards/v1/techstack//01_webclient.png',
                    imageName: languageTokens.boxOfCardsV1WebClientImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1TechStackSectionHeader_01,
                    description: languageTokens.boxOfCardsV1TechStackSectionDescription_01,
                    size: {
                        width: 600,

                    }
                },
                {
                    image: 'projects/web/boxofcards/v1/techstack//02_backendservices.png',
                    imageName: languageTokens.boxOfCardsV1BackendServicesImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1TechStackSectionHeader_02,
                    description: languageTokens.boxOfCardsV1TechStackSectionDescription_02,
                },
                {
                    image: 'projects/web/boxofcards/v1/techstack//03_packages.png',
                    imageName: languageTokens.boxOfCardsV1PackagesImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1TechStackSectionHeader_03,
                    description: languageTokens.boxOfCardsV1TechStackSectionDescription_03,
                },
                {
                    image: 'projects/web/boxofcards/v1/techstack//04_googlecloudfunctions.png',
                    imageName: languageTokens.boxOfCardsV1GoogleCloudFunctionsImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1TechStackSectionHeader_04,
                    description: languageTokens.boxOfCardsV1TechStackSectionDescription_04,
                },
                {
                    image: 'projects/web/boxofcards/v1/techstack//05_rabbitmq.png',
                    imageName: languageTokens.boxOfCardsV1RabbitMqImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1TechStackSectionHeader_05,
                    description: languageTokens.boxOfCardsV1TechStackSectionDescription_05,
                },
                // Deployment
                {
                    descriptionHeader: languageTokens.boxOfCardsV1DeploymentSectionHeader_00,
                    description: languageTokens.boxOfCardsV1DeploymentSectionDescription_00,
                },
                {
                    image: 'projects/web/boxofcards/v1/deployment/01_gitWorkflow.png',
                    imageName: languageTokens.boxOfCardsV1GitWorkflowImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1DeploymentSectionHeader_01,
                    description: languageTokens.boxOfCardsV1DeploymentSectionDescription_01,
                },
                {
                    image: 'projects/web/boxofcards/v1/deployment/02_shellScript.png',
                    imageName: languageTokens.boxOfCardsV1ShellScriptImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1DeploymentSectionHeader_02,
                    description: languageTokens.boxOfCardsV1DeploymentSectionDescription_02,
                },
                // Tests
                {
                    image: 'projects/web/boxofcards/v1/tests/01_gameTests.png',
                    imageName: languageTokens.boxOfCardsV1GameTestsImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1TestsSectionHeader_01,
                    description: languageTokens.boxOfCardsV1TestsSectionDescription_01,
                    size: {
                        width: 600,

                    }

                },
                {
                    image: 'projects/web/boxofcards/v1/tests/02_timeoutHandler.png',
                    imageName: languageTokens.boxOfCardsV1TimeoutHandlerImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1TestsSectionHeader_02,
                    description: languageTokens.boxOfCardsV1TestsSectionDescription_02,
                },
                // Design
                {
                    descriptionHeader: languageTokens.boxOfCardsV1DesignSectionHeader_00,
                    description: languageTokens.boxOfCardsV1DesignSectionDescription_00,
                },
                {
                    image: 'projects/web/boxofcards/v1/design/01_oldDesign1.png',
                    imageName: languageTokens.boxOfCardsV1OldDesign1ImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1DesignSectionHeader_01,
                    description: languageTokens.boxOfCardsV1DesignSectionDescription_01,
                },
                {
                    image: 'projects/web/boxofcards/v1/design/02_oldDesign2.png',
                    imageName: languageTokens.boxOfCardsV1OldDesign2ImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1DesignSectionHeader_02,
                    description: languageTokens.boxOfCardsV1DesignSectionDescription_02,
                },
                //{
                //    image: 'projects/web/boxofcards/v1/design/03_pageRouting.png',
                //    descriptionHeader: languageTokens.boxOfCardsDesignSectionHeader_03,
                //    description: languageTokens.boxOfCardsDesignSectionDescription_03,
                //
                //},
                //{
                //    image: 'projects/web/boxofcards/v1/design/04_gameLoop.png',
                //    descriptionHeader: languageTokens.boxOfCardsDesignSectionHeader_04,
                //    description: languageTokens.boxOfCardsDesignSectionDescription_04,
                //
                //},
                //{
                //    image: 'projects/web/boxofcards/v1/design/05_firstUml.png',
                //    descriptionHeader: languageTokens.boxOfCardsDesignSectionHeader_05,
                //    description: languageTokens.boxOfCardsDesignSectionDescription_05,
                //
                //},
                //{
                //    image: 'projects/web/boxofcards/v1/design/06_communicationViaQueues.png',
                //    descriptionHeader: languageTokens.boxOfCardsDesignSectionHeader_06,
                //    description: languageTokens.boxOfCardsDesignSectionDescription_06,
                //
                //},
                {
                    image: 'projects/web/boxofcards/v1/design/07_firstLandingPage.png',
                    imageName: languageTokens.boxOfCardsV1FirstLandingPageImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1DesignSectionHeader_07,
                    description: languageTokens.boxOfCardsV1DesignSectionDescription_07,
                },
                {
                    image: 'projects/web/boxofcards/v1/design/08_secondLandingPage.png',
                    imageName: languageTokens.boxOfCardsV1SecondLandingPageImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1DesignSectionHeader_08,
                    description: languageTokens.boxOfCardsV1DesignSectionDescription_08,
                },
                {
                    image: 'projects/web/boxofcards/v1/design/09_loginDesigns.png',
                    imageName: languageTokens.boxOfCardsV1LoginDesignsImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1DesignSectionHeader_09,
                    description: languageTokens.boxOfCardsV1DesignSectionDescription_09,
                },
                {
                    image: 'projects/web/boxofcards/v1/design/10_logoAttempt.png',
                    imageName: languageTokens.boxOfCardsV1LogoAttemptImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1DesignSectionHeader_10,
                    description: languageTokens.boxOfCardsV1DesignSectionDescription_10,
                    size: {
                        width: 600,

                    }
                },
                {
                    image: 'projects/web/boxofcards/v1/design/11_landingPageDesigns.png',
                    imageName: languageTokens.boxOfCardsV1LandingPageDesignsImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1DesignSectionHeader_11,
                    description: languageTokens.boxOfCardsV1DesignSectionDescription_11,
                },
                {
                    image: 'projects/web/boxofcards/v1/design/12_gameDesign1.png',
                    imageName: languageTokens.boxOfCardsV1GameDesign1ImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1DesignSectionHeader_12,
                    description: languageTokens.boxOfCardsV1DesignSectionDescription_12,
                },
                {
                    image: 'projects/web/boxofcards/v1/design/13_peopleChooseFont.png',
                    imageName: languageTokens.boxOfCardsV1PeopleChooseFontImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1DesignSectionHeader_13,
                    description: languageTokens.boxOfCardsV1DesignSectionDescription_13,
                },
                // Obstacles
                {
                    descriptionHeader: languageTokens.boxOfCardsV1ObstaclesSectionHeader_00,
                    description: languageTokens.boxOfCardsV1ObstaclesSectionDescription_00,
                },
                {
                    image: 'projects/web/boxofcards/v1/obstacles/01_fontNoUmlauts.png',
                    imageName: languageTokens.boxOfCardsV1FontNoUmlautsImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ObstaclesSectionHeader_01,
                    description: languageTokens.boxOfCardsV1ObstaclesSectionDescription_01,
                },
                {
                    image: 'projects/web/boxofcards/v1/obstacles/02_fontDoesNotLikeBorders.png',
                    imageName: languageTokens.boxOfCardsV1FontDoesNotLikeBordersImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ObstaclesSectionHeader_02,
                    description: languageTokens.boxOfCardsV1ObstaclesSectionDescription_02,
                },
                {
                    image: 'projects/web/boxofcards/v1/obstacles/03_colorDifferenceOfMyMonitors.png',
                    imageName: languageTokens.boxOfCardsV1ColorDifferenceOfMyMonitorsImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ObstaclesSectionHeader_03,
                    description: languageTokens.boxOfCardsV1ObstaclesSectionDescription_03,
                },
                {
                    image: 'projects/web/boxofcards/v1/obstacles/04_types.png',
                    imageName: languageTokens.boxOfCardsV1ObstacleTypesImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ObstaclesSectionHeader_04,
                    description: languageTokens.boxOfCardsV1ObstaclesSectionDescription_04,
                },
                {
                    image: 'projects/web/boxofcards/v1/obstacles/05_Zeitplanung.png',
                    imageName: languageTokens.boxOfCardsV1ObstaclesZeitplanungImageDescription,
                    descriptionHeader: languageTokens.boxOfCardsV1ObstaclesSectionHeader_05,
                    description: languageTokens.boxOfCardsV1ObstaclesSectionDescription_05,
                },
            ],
            next:
                {
                    name: `${languageTokens.To} V2`,
                    route: "boxofcardsv2",
                },
            links: [
                {
                    prefix: "",
                    name: "boxof.cards",
                    address: "https://boxof.cards",
                },
            ],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        //homepage3D
        {
            mediaCardElement: {
                thumbnail: 'projects/web/homepage3D/5_Homepage3DPage.jpg',
                description: languageTokens.homepage3DDescription,
                name: languageTokens.homepage3DName,
                subHeader: languageTokens.homepage3DSubHeader,
                route: 'homepage3D',
            },
            sections: [
                {
                    video: "https://www.youtube.com/embed/xiPiswO5h4A",
                    imageName: languageTokens.homepage3DLandingPageImageDescription,
                    descriptionHeader: languageTokens.homepage3DSectionHeader_01,
                    description: languageTokens.homepage3DSectionDescription_01,
                },
                {
                    image: 'projects/web/homepage3D/2_Homepage3DFront.jpg',
                    imageName: languageTokens.homepage3D3DFontImageDescription,
                    descriptionHeader: languageTokens.homepage3DSectionHeader_02,
                    description: languageTokens.homepage3DSectionDescription_02,
                },
                {
                    image: 'projects/web/homepage3D/3_Homepage3DContract1.png',
                    imageName: languageTokens.homepage3D3DContract1ImageDescription,
                    descriptionHeader: languageTokens.homepage3DSectionHeader_03,
                    description: languageTokens.homepage3DSectionDescription_03,
                },
                {
                    image: 'projects/web/homepage3D/4_Homepage3DContract2.png',
                    imageName: languageTokens.homepage3D3DContract2ImageDescription,
                    descriptionHeader: languageTokens.homepage3DSectionHeader_04,
                    description: languageTokens.homepage3DSectionDescription_04,
                },
                {
                    image: 'projects/web/homepage3D/5_Homepage3DPage.jpg',
                    imageName: languageTokens.homepage3D3DPageImageDescription,
                    descriptionHeader: languageTokens.homepage3DSectionHeader_05,
                    description: languageTokens.homepage3DSectionDescription_05,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Bachelor
        {
            mediaCardElement: {
                thumbnail: 'projects/studying/nonEuclideanNavigationVr/7_vr_environment_euclidean.jpg',
                description: languageTokens.bachelorDescription,
                name: languageTokens.bachelorName,
                subHeader: languageTokens.bachelorSubHeader,
                route: 'nonEuclideanNavigationVr'
            },
            sections: [
                {
                    image: 'projects/studying/nonEuclideanNavigationVr/1_Start.jpg',
                    imageName: languageTokens.bachelorStartImageDescription,
                    descriptionHeader: languageTokens.bachelorSectionHeader_01,
                    description: languageTokens.bachelorSectionDescription_01,
                },
                {
                    video: "https://www.youtube.com/embed/3vwfOaQ6KBI",
                    imageName: languageTokens.bachelorVideoImageDescription,
                    descriptionHeader: languageTokens.bachelorSectionHeader_02,
                    description: languageTokens.bachelorSectionDescription_02,
                },
                {
                    image: 'projects/studying/nonEuclideanNavigationVr/3_hyperbolic_rooms.png',
                    imageName: languageTokens.bachelorHyperbolicRoomsImageDescription,
                    descriptionHeader: languageTokens.bachelorSectionHeader_03,
                    description: languageTokens.bachelorSectionDescription_03,
                },
                {
                    image: 'projects/studying/nonEuclideanNavigationVr/4_impossible_rooms_3Turns.PNG',
                    imageName: languageTokens.bachelorImpossibleRooms3TurnsImageDescription,
                    descriptionHeader: languageTokens.bachelorSectionHeader_04,
                    description: languageTokens.bachelorSectionDescription_04,
                },
                {
                    image: 'projects/studying/nonEuclideanNavigationVr/5_impossible_rooms_advantages.PNG',
                    imageName: languageTokens.bachelorImpossibleRoomsAdvantagesImageDescription,
                    descriptionHeader: languageTokens.bachelorSectionHeader_05,
                    description: languageTokens.bachelorSectionDescription_05,
                },
                {
                    image: 'projects/studying/nonEuclideanNavigationVr/6_portal.jpg',
                    imageName: languageTokens.bachelorPortalImageDescription,
                    descriptionHeader: languageTokens.bachelorSectionHeader_06,
                    description: languageTokens.bachelorSectionDescription_06,
                },
                {
                    image: 'projects/studying/nonEuclideanNavigationVr/7_vr_environment_euclidean.jpg',
                    imageName: languageTokens.bachelorEuclideanImageDescription,
                    descriptionHeader: languageTokens.bachelorSectionHeader_07,
                    description: languageTokens.bachelorSectionDescription_07,
                },
                {
                    image: 'projects/studying/nonEuclideanNavigationVr/8_vr_environment_non_euclidean.jpg',
                    imageName: languageTokens.bachelorNonEuclideanImageDescription,
                    descriptionHeader: languageTokens.bachelorSectionHeader_08,
                    description: languageTokens.bachelorSectionDescription_08,
                },
                {
                    image: 'projects/studying/nonEuclideanNavigationVr/9_component_view.PNG',
                    imageName: languageTokens.bachelorComponentViewImageDescription,
                    descriptionHeader: languageTokens.bachelorSectionHeader_09,
                    description: languageTokens.bachelorSectionDescription_09,
                },
            ],
            links: [
                {
                    prefix: `${languageTokens.GoogleDrive}: `,
                    name: languageTokens.bachelorThesis,
                    address: "https://drive.google.com/file/d/12beo2Flke734D_f7icdnEoxpy0tuwh-v/view?usp=sharing",
                }
            ],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Portals
        {
            mediaCardElement: {
                thumbnail: 'projects/prototypes/portals/Portals_Thumbnail.png',
                description: languageTokens.portalGunDescription,
                name: languageTokens.portalGunName,
                subHeader: languageTokens.portalGunSubHeader,
                route: 'portalGun',
            },
            sections: [
                {
                    video: 'https://www.youtube.com/embed/1L78ir0UVxE',
                    imageName: languageTokens.portalsVideoImageDescription,
                    descriptionHeader: languageTokens.portalGunSectionHeader_01,
                    description: languageTokens.portalGunSectionDescription_01,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // LaserEngraver
        {
            mediaCardElement: {
                thumbnail: 'projects/laserEngraving/1_laserEngraver_printingRevocation.jpg',
                description: languageTokens.laserEngraverDescription,
                name: languageTokens.laserEngraverName,
                subHeader: languageTokens.laserEngraverSubHeader,
                route: 'laserEngraver',
            },
            sections: [
                {
                    image: 'projects/laserEngraving/1_laserEngraver_printingRevocation.jpg',
                    imageName: languageTokens.laserEngraverImageDescription_01,
                    descriptionHeader: languageTokens.laserEngraverSectionHeader_01,
                    description: languageTokens.laserEngraverSectionDescription_01,
                },
                {
                    image: 'projects/laserEngraving/2_laserEngraver_openFront.jpg',
                    imageName: languageTokens.laserEngraverImageDescription_02,
                    descriptionHeader: languageTokens.laserEngraverSectionHeader_02,
                    description: languageTokens.laserEngraverSectionDescription_02,
                },
                {
                    image: 'projects/laserEngraving/3_laserEngraver_openTop.jpg',
                    imageName: languageTokens.laserEngraverImageDescription_03,
                    descriptionHeader: languageTokens.laserEngraverSectionHeader_03,
                    description: languageTokens.laserEngraverSectionDescription_03,
                },
                {
                    image: 'projects/laserEngraving/4_laserEngraver_airSupport.jpg',
                    imageName: languageTokens.laserEngraverImageDescription_04,
                    descriptionHeader: languageTokens.laserEngraverSectionHeader_04,
                    description: languageTokens.laserEngraverSectionDescription_04,
                    size: {
                        width: 400,
                    }
                },
                {
                    image: 'projects/laserEngraving/5_laserEngraver_compessor.jpg',
                    imageName: languageTokens.laserEngraverImageDescription_05,
                    descriptionHeader: languageTokens.laserEngraverSectionHeader_05,
                    description: languageTokens.laserEngraverSectionDescription_05,
                    size: {
                        width: 500,
                    }
                },
                {
                    image: 'projects/laserEngraving/6_laserEngraver_tests.jpg',
                    imageName: languageTokens.laserEngraverImageDescription_06,
                    descriptionHeader: languageTokens.laserEngraverSectionHeader_06,
                    description: languageTokens.laserEngraverSectionDescription_06,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: 'projects/laserEngraving/7_laserEngraver_stopper.jpg',
                    imageName: languageTokens.laserEngraverImageDescription_07,
                    descriptionHeader: languageTokens.laserEngraverSectionHeader_07,
                    description: languageTokens.laserEngraverSectionDescription_07,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: 'projects/laserEngraving/8_laserEngraver_knife.jpg',
                    imageName: languageTokens.laserEngraverImageDescription_08,
                    descriptionHeader: languageTokens.laserEngraverSectionHeader_08,
                    description: languageTokens.laserEngraverSectionDescription_08,
                    size: {
                        width: 700,
                    }
                },
                {
                    image: 'projects/laserEngraving/9_laserEngraver_lightburnRevocation.jpg',
                    imageName: languageTokens.laserEngraverImageDescription_08,
                    descriptionHeader: languageTokens.laserEngraverSectionHeader_08,
                    description: languageTokens.laserEngraverSectionDescription_08,
                    size: {
                        width: 800,
                    }
                },
                {
                    image: 'projects/laserEngraving/10_laserEngraver_printedRevocation.jpg',
                    imageName: languageTokens.laserEngraverImageDescription_09,
                    descriptionHeader: languageTokens.laserEngraverSectionHeader_09,
                    description: languageTokens.laserEngraverSectionDescription_09,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Homepage2D
        {
            mediaCardElement: {
                thumbnail: 'projects/web/homepage2D/01_homepage2d',
                description: languageTokens.homepage2DDescription,
                name: languageTokens.homepage2DName,
                subHeader: languageTokens.homepage2DSubHeader,
                route: 'homepage2d',
            },
            sections: [
                {
                    image: "projects/web/homepage2D/01_homepage2d",
                    imageName: languageTokens.homepage2DImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_01,
                    description: languageTokens.homepage2DSectionDescription_01,
                },
                {
                    image: "projects/web/homepage2D/02_homepage2D_frontend",
                    imageName: languageTokens.homepage2DFrontendImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_02,
                    description: languageTokens.homepage2DSectionDescription_02,
                    size: {
                        width: 300,
                    }
                },
                {
                    image: "projects/web/homepage2D/03_homepage2D_colorpalettes",
                    imageName: languageTokens.homepage2DColorPalettesImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_03,
                    description: languageTokens.homepage2DSectionDescription_03,
                },
                {
                    image: "projects/web/homepage2D/04_homepage2D_materialui-css",
                    imageName: languageTokens.homepage2DMuiImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_04,
                    description: languageTokens.homepage2DSectionDescription_04,
                },
                {
                    image: "projects/web/homepage2D/05_homepage2D_reduxstore",
                    imageName: languageTokens.homepage2DReduxImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_05,
                    description: languageTokens.homepage2DSectionDescription_05,
                },
                {
                    image: "projects/web/homepage2D/06_homepage2D_contactpage",
                    imageName: languageTokens.homepage2DContactPageImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_06,
                    description: languageTokens.homepage2DSectionDescription_06,
                },
                {
                    image: "projects/web/homepage2D/07_homepage2D_frontend_dev",
                    imageName: languageTokens.homepage2DFrontendDevImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_07,
                    description: languageTokens.homepage2DSectionDescription_07,
                    size: {
                        width: 300,

                    }
                },
                {
                    image: "projects/web/homepage2D/08_homepage2D_exampleproject",
                    imageName: languageTokens.homepage2DExampleProjectImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_08,
                    description: languageTokens.homepage2DSectionDescription_08,
                },
                {
                    image: "projects/web/homepage2D/09_homepage2D_projecttypes",
                    imageName: languageTokens.homepage2DProjectTypesImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_09,
                    description: languageTokens.homepage2DSectionDescription_09,
                },
                {
                    image: "projects/web/homepage2D/10_homepage2D_dockerfile",
                    imageName: languageTokens.homepage2DDockerFileImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_10,
                    description: languageTokens.homepage2DSectionDescription_10,
                },
                {
                    image: "projects/web/homepage2D/11_homepage2D_deployment",
                    imageName: languageTokens.homepage2DeploymentImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_11,
                    description: languageTokens.homepage2DSectionDescription_11,
                    size: {
                        width: 300,

                    }
                },
                {
                    image: "projects/web/homepage2D/12_homepage2D_utilities",
                    imageName: languageTokens.homepage2DUtilitiesImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_12,
                    description: languageTokens.homepage2DSectionDescription_12,
                    size: {
                        width: 300,

                    }
                },
                {
                    image: "projects/web/homepage2D/13_homepage2D_imagekitio",
                    imageName: languageTokens.homepage2DImageKitIoImageDescription,
                    descriptionHeader: languageTokens.homepage2DSectionHeader_13,
                    description: languageTokens.homepage2DSectionDescription_13,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },

        // DinoKing
        {
            mediaCardElement: {
                thumbnail: 'projects/2D/dinoKing/DinoKing.png',
                description: languageTokens.dinoKingThumbnailDescription,
                name: languageTokens.dinoKingName,
                subHeader: languageTokens.dinoKingSubHeader,
                route: 'dinoKing'
            },
            sections: [
                {
                    image: "projects/2D/dinoKing/DinoKing.png",
                    imageName: languageTokens.dinoKingImageDescription,
                    descriptionHeader: languageTokens.Gameplay,
                    description: languageTokens.dinoKingSectionDescription_01,
                },
                {
                    image: "projects/2D/dinoKing/DinoKing_Dinos.gif",
                    imageName: languageTokens.dinoKingDinosImageDescription,
                    descriptionHeader: languageTokens.dinoKingSectionHeader_02,
                    description: languageTokens.dinoKingSectionDescription_02,
                }
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Skyblock
        {
            mediaCardElement: {
                thumbnail: 'projects/3D/skyblock/Skyblock.png',
                description: languageTokens.skyBlockDescription,
                name: languageTokens.skyBlockName,
                subHeader: languageTokens.skyBlockSubHeader,
                route: 'skyblock'
            },
            sections: [
                {
                    image: "projects/3D/skyblock/Skyblock.png",
                    imageName: languageTokens.skyBlockImageDescription,
                    descriptionHeader: languageTokens.skyBlockSectionHeader_01,
                    description: languageTokens.skyBlockSectionDescription_01,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Corridor
        {
            mediaCardElement: {
                thumbnail: 'projects/3D/corridor/Corridor.jpg',
                description: languageTokens.corridorDescription,
                name: languageTokens.corridorName,
                subHeader: languageTokens.corridorSubHeader,
                route: 'corridor'
            },
            sections: [
                {
                    image: "projects/3D/corridor/Corridor.jpg",
                    imageName: languageTokens.corridorImageDescription,
                    descriptionHeader: languageTokens.corridorSectionHeader_01,
                    description: languageTokens.corridorSectionDescription_01,
                },
                {
                    image: "projects/3D/corridor/Corridor_Reference.jpg",
                    imageName: languageTokens.corridorReferenceImageDescription,
                    descriptionHeader: languageTokens.corridorSectionHeader_02,
                    description: languageTokens.corridorSectionDescription_02,
                    size: {
                        width: 600,

                    }
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Door
        {
            mediaCardElement: {
                thumbnail: 'projects/3D/door/Door.jpg',
                description: languageTokens.doorDescription,
                name: languageTokens.doorName,
                subHeader: languageTokens.doorSubHeader,
                route: 'door'
            },
            sections: [
                {
                    image: "projects/3D/door/Door.jpg",
                    imageName: languageTokens.doorImageDescription,
                    descriptionHeader: languageTokens.doorSectionHeader_01,
                    description: languageTokens.doorSectionDescription_01,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Shield
        {
            mediaCardElement: {
                thumbnail: 'projects/3D/shield/1Shield_Front.jpg',
                description: languageTokens.shieldDescription,
                name: languageTokens.shieldName,
                subHeader: languageTokens.shieldSubHeader,
                route: 'shield'
            },
            sections: [
                {
                    image: "projects/3D/shield/1Shield_Front.jpg",
                    imageName: languageTokens.shieldFrontImageDescription,
                    descriptionHeader: languageTokens.shieldSectionHeader_01,
                    description: languageTokens.shieldSectionDescription_01,
                },
                {
                    image: "projects/3D/shield/2Shield_Back.jpg",
                    imageName: languageTokens.shieldBackImageDescription,
                    descriptionHeader: languageTokens.shieldSectionHeader_02,
                    description: languageTokens.shieldSectionDescription_02,
                },
                {
                    image: "projects/3D/shield/3Shield_Side.jpg",
                    imageName: languageTokens.shieldSideImageDescription,
                    descriptionHeader: languageTokens.shieldSectionHeader_03,
                    description: languageTokens.shieldSectionDescription_03,
                },
                {
                    image: "projects/3D/shield/4Shield_Reference.jpg",
                    imageName: languageTokens.shieldReferenceImageDescription,
                    descriptionHeader: languageTokens.shieldSectionHeader_04,
                    description: languageTokens.shieldSectionDescription_04,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Spider
        {
            mediaCardElement: {
                thumbnail: 'projects/3D/spider/1MechSpider_Front.jpg',
                description: languageTokens.spiderDescription,
                name: languageTokens.spiderName,
                subHeader: languageTokens.spiderSubHeader,
                route: 'spider'
            },
            sections: [
                {
                    image: 'projects/3D/spider/1MechSpider_Front.jpg',
                    imageName: languageTokens.spiderFrontImageDescription,
                    descriptionHeader: languageTokens.spiderSectionHeader_01,
                    description: languageTokens.spiderSectionDescription_01,
                },
                {
                    image: 'projects/3D/spider/2MechSpider_Back.jpg',
                    imageName: languageTokens.spiderBackImageDescription,
                    descriptionHeader: languageTokens.spiderSectionHeader_02,
                    description: languageTokens.spiderSectionDescription_02,
                },
                {
                    image: 'projects/3D/spider/3MechSpider_FrontWireframe.jpg',
                    imageName: languageTokens.spiderFrontWireframeImageDescription,
                    descriptionHeader: languageTokens.spiderSectionHeader_03,
                    description: languageTokens.spiderSectionDescription_03,
                },
                {
                    image: 'projects/3D/spider/4MechSpider_BackWireframe.jpg',
                    imageName: languageTokens.spiderBackWireFrameImageDescription,
                    descriptionHeader: languageTokens.spiderSectionHeader_04,
                    description: languageTokens.spiderSectionDescription_04,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Staff
        {
            mediaCardElement: {
                thumbnail: 'projects/3D/staff/Staff.jpg',
                description: languageTokens.staffDescription,
                name: languageTokens.staffName,
                subHeader: languageTokens.staffSubHeader,
                route: 'staff'
            },
            sections: [
                {
                    image: "projects/3D/staff/Staff.jpg",
                    imageName: languageTokens.staffImageDescription,
                    descriptionHeader: languageTokens.staffSectionHeader_01,
                    description: languageTokens.staffSectionDescription_01,
                },
                {
                    image: "projects/3D/staff/Staff_Reference.jpg",
                    imageName: languageTokens.staffReferenceImageDescription,
                    descriptionHeader: languageTokens.staffSectionHeader_02,
                    description: languageTokens.staffSectionDescription_02,
                    size: {
                        width: 600,

                    }
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // planets
        {
            mediaCardElement: {
                thumbnail: 'projects/3D/planets/planet.jpg',
                description: languageTokens.planetsDescription,
                name: languageTokens.planetsName,
                subHeader: languageTokens.planetsSubHeader,
                route: 'planets'
            },
            sections: [
                {
                    image: "projects/3D/planets/planet.jpg",
                    imageName: languageTokens.planetsPlanetImageDescription,
                    descriptionHeader: languageTokens.planetsSectionHeader_01,
                    description: languageTokens.planetsSectionDescription_01,
                    size: {
                        width: 600,
                    }
                },
                {
                    image: "projects/3D/planets/planets.jpg",
                    imageName: languageTokens.planetsPlanetsImageDescription,
                    descriptionHeader: languageTokens.planetsSectionHeader_02,
                    description: languageTokens.planetsSectionDescription_02,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // symbolQuest
        {
            mediaCardElement: {
                thumbnail: 'projects/games/symbolQuest/SymbolQuest.png',
                description: languageTokens.symbolQuestDescription,
                name: languageTokens.symbolQuestName,
                subHeader: languageTokens.symbolQuestSubHeader,
                route: 'symbolQuest'
            },
            sections: [
                {
                    image: "projects/games/symbolQuest/SymbolQuest.png",
                    imageName: languageTokens.symbolQuestImageDescription,
                    descriptionHeader: languageTokens.symbolQuestSectionHeader_01,
                    description: languageTokens.symbolQuestSectionDescription_01,
                    size: {
                        width: 600,
                    }
                },
                {
                    video: "https://www.youtube.com/embed/3V9OpiIuZ_E",
                    imageName: languageTokens.symbolQuestVideoImageDescription,
                    descriptionHeader: languageTokens.symbolQuestSectionHeader_02,
                    description: languageTokens.symbolQuestSectionDescription_02,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        {
            mediaCardElement: {
                thumbnail: 'projects/games/terribleTower/00_TT_Titlescreen.jpg',
                description: languageTokens.terribleTowerDescription,
                name: languageTokens.terribleTowerName,
                subHeader: languageTokens.terribleTowerSubHeader,
                route: 'terribleTower'
            },
            sections: [
                {
                    image: "projects/games/terribleTower/00_TT_Titlescreen.jpg",
                    imageName: languageTokens.terribleTowerTitleScreenImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_00,
                    description: languageTokens.terribleTowerSectionDescription_00,
                    size: {
                        width: 600,
                    }
                },
                {
                    video: "https://www.youtube.com/embed/-GFPT3hYTTw",
                    imageName: languageTokens.terribleTowerVideoImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeaderTrailer,
                    description: languageTokens.terribleTowerSectionDescriptionTrailer,
                },
                {
                    image: "projects/games/terribleTower/01_TT_StoneAge.jpg",
                    imageName: languageTokens.terribleTowerStoneAgeImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_01,
                    description: languageTokens.terribleTowerSectionDescription_01,
                },
                {
                    image: "projects/games/terribleTower/02_TT_RuneAge.jpg",
                    imageName: languageTokens.terribleTowerRuneAgeImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_02,
                    description: languageTokens.terribleTowerSectionDescription_02,
                },
                {
                    image: "projects/games/terribleTower/03_TT_RomeAge.jpg",
                    imageName: languageTokens.terribleTowerRomeAgeImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_03,
                    description: languageTokens.terribleTowerSectionDescription_03,
                },
                {
                    image: "projects/games/terribleTower/04_TT_MedievalAge.jpg",
                    imageName: languageTokens.terribleTowerMedievalAgeImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_04,
                    description: languageTokens.terribleTowerSectionDescription_04,
                },
                {
                    image: "projects/games/terribleTower/05_TT_IndustrialAge.jpg",
                    imageName: languageTokens.terribleTowerIndustrialAgeImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_05,
                    description: languageTokens.terribleTowerSectionDescription_05,
                },
                {
                    image: "projects/games/terribleTower/06_TT_Artage.jpg",
                    imageName: languageTokens.terribleTowerArtAgeImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_06,
                    description: languageTokens.terribleTowerSectionDescription_06,
                },
                {
                    image: "projects/games/terribleTower/07_TT_AtomAge.jpg",
                    imageName: languageTokens.terribleTowerAtomAgeImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_07,
                    description: languageTokens.terribleTowerSectionDescription_07,
                },
                {
                    image: "projects/games/terribleTower/08_TT_Matrixage.jpg",
                    imageName: languageTokens.terribleTowerMatrixAgeImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_08,
                    description: languageTokens.terribleTowerSectionDescription_08,
                },
                {
                    image: "projects/games/terribleTower/09_TT_SciFiAge.jpg",
                    imageName: languageTokens.terribleTowerSciFiAgeImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_09,
                    description: languageTokens.terribleTowerSectionDescription_09,
                },
                {
                    image: "projects/games/terribleTower/10_TT_Endage.jpg",
                    imageName: languageTokens.terribleTowerEndAgeImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_10,
                    description: languageTokens.terribleTowerSectionDescription_10,
                },
                {
                    image: "projects/games/terribleTower/11_TT_Menu.jpg",
                    imageName: languageTokens.terribleTowerMenuImageDescription,
                    descriptionHeader: languageTokens.terribleTowerSectionHeader_11,
                    description: languageTokens.terribleTowerSectionDescription_11,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // PenAndPaperVr
        {
            mediaCardElement: {
                thumbnail: 'projects/studying/penAndPaperVr/CharSheetPreview.jpg',
                description: languageTokens.penAndPaperVrDescription,
                name: languageTokens.penAndPaperVrName,
                subHeader: languageTokens.penAndPaperVrSubHeader,
                route: 'penAndPaperVr',
            },
            sections: [
                {
                    image: 'projects/studying/penAndPaperVr/CharSheetPreview.jpg',
                    imageName: languageTokens.penAndPaperVrCharSheetImageDescription,
                    descriptionHeader: languageTokens.penAndPaperVrSectionHeader_01,
                    description: languageTokens.penAndPaperVrSectionDescription_01,
                },
                {
                    image: 'projects/studying/penAndPaperVr/CharSheetEdited.jpg',
                    imageName: languageTokens.penAndPaperVrCharSheetEditedImageDescription,
                    descriptionHeader: languageTokens.penAndPaperVrSectionHeader_02,
                    description: languageTokens.penAndPaperVrSectionDescription_02,
                },
                {
                    image: 'projects/studying/penAndPaperVr/EnvironmentAdded.jpg',
                    imageName: languageTokens.penAndPaperVrEnvironmentAddedImageDescription,
                    descriptionHeader: languageTokens.penAndPaperVrSectionHeader_03,
                    description: languageTokens.penAndPaperVrSectionDescription_03,
                },
                {
                    image: 'projects/studying/penAndPaperVr/Cube.jpg',
                    imageName: languageTokens.penAndPaperVrCubeImageDescription,
                    descriptionHeader: languageTokens.penAndPaperVrSectionHeader_04,
                    description: languageTokens.penAndPaperVrSectionDescription_04,
                    size: {
                        width: 600,
                    }
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        //MachineLearning
        {
            mediaCardElement: {
                thumbnail: 'projects/studying/machineLearning/CAS_thumbnail.jpg',
                description: languageTokens.machineLearningDescription,
                name: languageTokens.machineLearningName,
                subHeader: languageTokens.machineLearningSubHeader,
                route: 'machineLearning',
            },
            sections: [
                {
                    video: 'https://www.youtube.com/embed/2VLYbAdGenk',
                    imageName: languageTokens.machineLearningVideoImageDescription,
                    descriptionHeader: languageTokens.machineLearningSectionHeader_01,
                    description: languageTokens.machineLearningSectionDescription_01,
                },
                {
                    image: 'projects/studying/machineLearning/Regelselektion.jpg',
                    imageName: languageTokens.machineLearningRuleSelectionImageDescription,
                    descriptionHeader: languageTokens.machineLearningSectionHeader_02,
                    description: languageTokens.machineLearningSectionDescription_02,
                    size: {
                        width: 400,
                    }
                },
            ],
            links: [
                {
                    prefix: `${languageTokens.GoogleDrive}: `,
                    name: languageTokens.machineLearningPaper,
                    address: "https://drive.google.com/file/d/1GJbggizbFd3ScvkZilPfF9FeT1fJ4E3f/view?usp=sharing",
                }
            ],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Empfängnis
        {
            mediaCardElement: {
                thumbnail: 'projects/books/book_empfaengnis',
                description: languageTokens.empfaengnisDescription,
                name: languageTokens.empfaengnisName,
                subHeader: languageTokens.empfaengnisSubHeader,
                route: 'empfaengnis',
            },
            sections: [
                {
                    image: 'projects/books/book_empfaengnis',
                    imageName: languageTokens.empfaengnisImageDescription,
                    descriptionHeader: languageTokens.empfaengnisSectionHeader_01,
                    description: languageTokens.empfaengnisSectionDescription_01,
                    size: {
                        width: 800,
                    }
                },
            ],
            links: [
                {
                    prefix: "",
                    name: "amazon",
                    address: "https://www.amazon.de/Empf%C3%A4ngnis-Siegelweltgeschichten-1-Tim-Beier-ebook/dp/B009I4RIQI/",
                }
            ],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        //pimpTheLimb
        {
            mediaCardElement: {
                thumbnail: 'projects/prototypes/pimpTheLimb/PimpTheLimb_Thumbnail.png',
                description: languageTokens.pimpTheLimbDescription,
                name: languageTokens.pimpTheLimbName,
                subHeader: languageTokens.pimpTheLimbSubHeader,
                route: 'pimpTheLimb',
            },
            sections: [
                {
                    video: 'https://www.youtube.com/embed/VP0W-R8-ICI',
                    imageName: languageTokens.pimpTheLimbVideoImageDescription,
                    descriptionHeader: languageTokens.pimpTheLimbSectionHeader_01,
                    description: languageTokens.pimpTheLimbSectionDescription_01,
                },
                {
                    image: 'projects/prototypes/pimpTheLimb/v1.png',
                    imageName: languageTokens.pimpTheLimbV1ImageDescription,
                    descriptionHeader: languageTokens.pimpTheLimbSectionHeader_02,
                    description: languageTokens.pimpTheLimbSectionDescription_02,
                    size: {
                        width: 200,
                        height: 200,
                    }
                },
                {
                    image: 'projects/prototypes/pimpTheLimb/v2.png',
                    imageName: languageTokens.pimpTheLimbV2ImageDescription,
                    descriptionHeader: languageTokens.pimpTheLimbSectionHeader_03,
                    description: languageTokens.pimpTheLimbSectionDescription_03,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // StealthCommander
        {
            mediaCardElement: {
                thumbnail: 'projects/prototypes/stealthCommander/StealthCommander_Thumbnail.png',
                description: languageTokens.stealthCommanderDescription,
                name: languageTokens.stealthCommanderName,
                subHeader: languageTokens.stealthCommanderSubHeader,
                route: 'curves',
            },
            sections: [
                {
                    video: 'https://www.youtube.com/embed/7ZjyJPMk5Nc',
                    imageName: languageTokens.stealthCommanderVideoImageDescription,
                    descriptionHeader: languageTokens.stealthCommanderSectionHeader_01,
                    description: languageTokens.stealthCommanderSectionDescription_01,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // GrimRepair
        {
            mediaCardElement: {
                thumbnail: 'projects/gameJams/grimRepair/GrimRepair_Thumbnail.png',
                description: languageTokens.grimRepairDescription,
                name: languageTokens.grimRepairName,
                subHeader: languageTokens.grimRepairSubHeader,
                route: 'grimRepair',
            },
            sections: [
                {
                    video: 'https://www.youtube.com/embed/m4lXb1T_D8o',
                    imageName: languageTokens.grimRepairVideoImageDescription,
                    descriptionHeader: languageTokens.grimRepairSectionHeader_01,
                    description: languageTokens.grimRepairSectionDescription_01,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
        // Catastrophic
        {
            mediaCardElement: {
                thumbnail: 'projects/gameJams/catastrophic/Catastrophic_Thumbnail.jpg',
                description: languageTokens.catastrophicDescription,
                name: languageTokens.catastrophicName,
                subHeader: languageTokens.catastrophicSubHeader,
                route: 'catastrophic',
            },
            sections: [
                {
                    video: 'https://www.youtube.com/embed/MXm_HQxDS1w',
                    imageName: languageTokens.catastrophicVideoImageDescription,
                    descriptionHeader: languageTokens.catastrophicSectionHeader_01,
                    description: languageTokens.catastrophicSectionDescription_01,
                },
            ],
            links: [],
            downloads: [],
            creators: [languageTokens.teamMember01Name],
        },
    ];
}

export const CAREER_SECTIONS = (languageTokens: ILanguageTokens): ICareerSection[] => {
    return [
        {
            year: "Today",
            careerProjects: [
                {
                    date: `06.2024 - ${languageTokens.today}`,
                    header: languageTokens.boxOfCardsV3CareerHeader,
                    subHeader: languageTokens.boxOfCardsV3CareerSubHeader,
                    description: languageTokens.boxOfCardsV3CareerDescription,
                    bulletPoints: [
                        languageTokens.boxOfCardsV3CareerBulletPoint1,
                        languageTokens.boxOfCardsV3CareerBulletPoint2,
                        languageTokens.boxOfCardsV3CareerBulletPoint3,
                        languageTokens.boxOfCardsV3CareerBulletPoint4,
                        languageTokens.boxOfCardsV3CareerBulletPoint5,
                        languageTokens.boxOfCardsV3CareerBulletPoint6,
                    ],
                    skills: [
                        languageTokens.typescript,
                        languageTokens.mui,
                        languageTokens.websockets,
                        languageTokens.react,
                        languageTokens.rtk,
                        languageTokens.rtkQuery,
                        languageTokens.nodeJs,
                        languageTokens.digitalOcean,
                        languageTokens.jest,
                        languageTokens.docker,
                        languageTokens.aws,
                        languageTokens.awsCdk,
                        languageTokens.awsCloudformation,
                        languageTokens.awsS3,
                        languageTokens.awsRoute53,
                        languageTokens.awsCloudwatch,
                        languageTokens.awsCloudFront,
                        languageTokens.affinityDesigner,
                        languageTokens.affinityPhoto,
                    ],
                },
            ],
        },
        {
            year: "2025",
            careerProjects: [
                {
                    date: `03.2025 - ${languageTokens.today}`,
                    header: languageTokens.hrisHeader,
                    subHeader: languageTokens.hrisSubHeader,
                    description: languageTokens.hrisDescription,
                    bulletPoints: [
                        languageTokens.hrisBulletPoint1,
                        languageTokens.hrisBulletPoint2,
                        languageTokens.hrisBulletPoint3,
                        languageTokens.hrisBulletPoint4,
                        languageTokens.hrisBulletPoint5,
                        languageTokens.hrisBulletPoint6,
                    ],
                    skills: [
                        languageTokens.typescript,
                        languageTokens.mui,
                        languageTokens.websockets,
                        languageTokens.react,
                        languageTokens.redux,
                        languageTokens.nodeJs,
                        languageTokens.jest,
                        languageTokens.docker,
                        languageTokens.sharepoint,
                        languageTokens.microsoftGraphApi,
                        languageTokens.azure,
                        languageTokens.azureAd,
                        languageTokens.aws,
                        languageTokens.awsCdk,
                        languageTokens.awsCloudformation,
                        languageTokens.awsLambda,
                        languageTokens.awsS3,
                        languageTokens.awsDynamoDb,
                        languageTokens.awsRoute53,
                        languageTokens.githubCiCd,
                        languageTokens.affinityDesigner,
                        languageTokens.affinityPhoto,
                        languageTokens.chatGpt,
                    ],
                },
                {
                    date: `11.2024 - 01.2025`,
                    header: languageTokens.kotlinRecommendationAppHeader,
                    subHeader: languageTokens.kotlinRecommendationAppSubHeader,
                    description: languageTokens.kotlinRecommendationAppDescription,
                    bulletPoints: [],
                    skills: [
                        languageTokens.android,
                        languageTokens.kotlin,
                        languageTokens.maven,
                        languageTokens.material,
                        languageTokens.chatGpt,
                    ],
                },
            ]
        },
        {
            year: "2024",
            careerProjects: [
                {
                    date: '03.2024 - 11.2024',
                    header: languageTokens.charityHeader,
                    subHeader: languageTokens.charitySubHeader,
                    description: languageTokens.charityDescription,
                    bulletPoints: [
                        languageTokens.charityBulletPoint1,
                        languageTokens.charityBulletPoint2,
                        languageTokens.charityBulletPoint3,
                        languageTokens.charityBulletPoint4,
                        languageTokens.charityBulletPoint5,
                        languageTokens.charityBulletPoint6,
                    ],
                    skills: [
                        languageTokens.nodeJs,
                        languageTokens.nextJs,
                        languageTokens.prisma,
                        languageTokens.react,
                        languageTokens.rtk,
                        languageTokens.postgreSQL,
                        languageTokens.azure,
                        languageTokens.githubCiCd],
                },
                {
                    date: `08.2022 - 06.2024`,
                    header: languageTokens.boxOfCardsV2CareerHeader,
                    subHeader: languageTokens.boxOfCardsV2CareerSubHeader,
                    description: languageTokens.boxOfCardsV2CareerDescription,
                    bulletPoints: [
                        languageTokens.boxOfCardsV2CareerBulletPoint1,
                        languageTokens.boxOfCardsV2CareerBulletPoint2,
                        languageTokens.boxOfCardsV2CareerBulletPoint3,
                        languageTokens.boxOfCardsV2CareerBulletPoint4,
                        languageTokens.boxOfCardsV2CareerBulletPoint5,
                    ],
                    skills: [
                        languageTokens.typescript,
                        languageTokens.mui,
                        languageTokens.websockets,
                        languageTokens.react,
                        languageTokens.rtk,
                        languageTokens.rtkQuery,
                        languageTokens.nodeJs,
                        languageTokens.jest,
                        languageTokens.docker,
                        languageTokens.graphql,
                        languageTokens.apollo,
                        languageTokens.aws,
                        languageTokens.awsCdk,
                        languageTokens.awsCloudformation,
                        languageTokens.awsLambda,
                        languageTokens.apiGateway,
                        languageTokens.appsync,
                        languageTokens.awsS3,
                        languageTokens.awsRoute53,
                        languageTokens.awsDynamoDb,
                        languageTokens.awsCloudwatch,
                        languageTokens.awsCloudFront,
                        languageTokens.affinityDesigner,
                        languageTokens.affinityPhoto,
                        languageTokens.chatGpt,
                    ],
                },
                {
                    date: '08.2023 - 02.2024',
                    header: languageTokens.agricultureHeader,
                    subHeader: languageTokens.agricultureSubHeader,
                    description: languageTokens.agricultureDescription,
                    bulletPoints: [
                        languageTokens.agricultureBulletPoint1,
                        languageTokens.agricultureBulletPoint2,
                        languageTokens.agricultureBulletPoint3,
                        languageTokens.agricultureBulletPoint4,
                        languageTokens.agricultureBulletPoint5,
                        languageTokens.agricultureBulletPoint6,
                        languageTokens.agricultureBulletPoint7,
                    ],
                    skills: [
                        languageTokens.azure,
                        languageTokens.dotNet,
                        languageTokens.entityFramework,
                        languageTokens.postgreSQL,
                        languageTokens.swagger,
                        languageTokens.xUnit,
                        languageTokens.moq,
                        languageTokens.react,
                        languageTokens.mui,
                        languageTokens.muiDatagrid,
                        languageTokens.yup,
                        languageTokens.rtk,
                        languageTokens.rtkQuery,
                        languageTokens.scrum,
                        languageTokens.businessProcessReengineering,
                        languageTokens.textControl,
                        languageTokens.figma,
                        languageTokens.miro
                    ],
                },
            ]
        },
        {
            year: "2023",
            careerProjects: [
                {
                    date: '01.2023 - 07.2023',
                    header: languageTokens.eCommerceHeader,
                    subHeader: languageTokens.eCommerceSubHeader,
                    description: languageTokens.eCommerceDescription,
                    bulletPoints: [
                        languageTokens.eCommerceBulletPoint1,
                        languageTokens.eCommerceBulletPoint2,
                        languageTokens.eCommerceBulletPoint3,
                        languageTokens.eCommerceBulletPoint4,
                        languageTokens.eCommerceBulletPoint5,
                        languageTokens.eCommerceBulletPoint6,
                        languageTokens.eCommerceBulletPoint7,
                        languageTokens.eCommerceBulletPoint8,
                    ],
                    skills: [
                        languageTokens.aws,
                        languageTokens.awsCdk,
                        languageTokens.awsEc2,
                        languageTokens.awsFargate,
                        languageTokens.awsEcr,
                        languageTokens.awsS3,
                        languageTokens.awsDynamoDb,
                        languageTokens.awsLambda,
                        languageTokens.awsSns,
                        languageTokens.awsSqs,
                        languageTokens.awsCloudwatch,
                        languageTokens.awsCloudformation,
                        languageTokens.terraform,
                        languageTokens.keycloak,
                        languageTokens.githubCiCd,
                        languageTokens.docker,
                        languageTokens.rabbitMq,
                        languageTokens.kafka,
                        languageTokens.java,
                        languageTokens.hibernate,
                        languageTokens.springIntegration,
                        languageTokens.jUnit,
                        languageTokens.maven,
                        languageTokens.typescript,
                        languageTokens.angularMaterial,
                        languageTokens.yarn,
                        languageTokens.liquidJs,
                        languageTokens.emarsys,
                        languageTokens.confluence,
                        languageTokens.miro,
                    ],
                },
                {
                    date: '09.2022 - 01.2023',
                    header: languageTokens.bookingHeader,
                    subHeader: languageTokens.bookingSubHeader,
                    description: languageTokens.bookingDescription,
                    bulletPoints: [
                        languageTokens.bookingBulletPoint1,
                        languageTokens.bookingBulletPoint2,
                        languageTokens.bookingBulletPoint3,
                        languageTokens.bookingBulletPoint4,
                        languageTokens.bookingBulletPoint5,
                    ],
                    skills: [
                        languageTokens.aws,
                        languageTokens.awsCdk,
                        languageTokens.awsCognito,
                        languageTokens.awsEcs,
                        languageTokens.awsFargate,
                        languageTokens.awsAurora,
                        languageTokens.awsRoute53,
                        languageTokens.awsCloudwatch,
                        languageTokens.awsCloudformation,
                        languageTokens.gitlabCiCd,
                        languageTokens.docker,
                        languageTokens.java,
                        languageTokens.springBoot,
                        languageTokens.swagger,
                        languageTokens.azure,
                        languageTokens.typescript,
                        languageTokens.vite,
                        languageTokens.mui,
                        languageTokens.react,
                        languageTokens.rtk,
                        languageTokens.rtkQuery,
                        languageTokens.yup,
                        languageTokens.miro,
                        languageTokens.figma,
                    ],
                }
            ]
        },
        {
            year: "2022",
            careerProjects: [
                {
                    date: '',
                    header: languageTokens.awsSolutionArchitectHeader,
                    subHeader: languageTokens.awsSolutionArchitectSubHeader,
                    description: languageTokens.awsSolutionArchitectDescription,
                    bulletPoints: [],
                    skills: [languageTokens.aws],
                },
                {
                    date: '',
                    header: languageTokens.awsCloudPractitionerHeader,
                    subHeader: languageTokens.awsCloudPractitionerSubHeader,
                    description: languageTokens.awsCloudPractitionerDescription,
                    bulletPoints: [],
                    skills: [languageTokens.aws],
                },
                {
                    date: '08.2021 - 06.2022',
                    header: languageTokens.boxOfCardsV1CareerHeader,
                    subHeader: languageTokens.boxOfCardsV1CareerSubHeader,
                    description: languageTokens.boxOfCardsV1CareerDescription,
                    bulletPoints: [
                        languageTokens.boxOfCardsV1CareerBulletPoint1,
                        languageTokens.boxOfCardsV1CareerBulletPoint2,
                        languageTokens.boxOfCardsV1VCareerBulletPoint3,
                        languageTokens.boxOfCardsV1CareerBulletPoint4,
                        languageTokens.boxOfCardsV1CareerBulletPoint5,

                    ],
                    skills: [
                        languageTokens.typescript,
                        languageTokens.mui,
                        languageTokens.websockets,
                        languageTokens.react,
                        languageTokens.redux,
                        languageTokens.nodeJs,
                        languageTokens.jest,
                        languageTokens.docker,
                        languageTokens.redis,
                        languageTokens.kubernetes,
                        languageTokens.gcp,
                        languageTokens.firebase,
                        languageTokens.githubCiCd,
                        languageTokens.affinityDesigner,
                        languageTokens.affinityPhoto
                    ],
                },
                {
                    date: '04.2021 - 10.2021',
                    header: languageTokens.fundingHeader,
                    subHeader: languageTokens.fundingSubHeader,
                    description: languageTokens.fundingDescription,
                    bulletPoints: [],
                    skills: [],
                },
                {
                    date: '',
                    header: languageTokens.diagnosisAdhdHeader,
                    subHeader: languageTokens.diagnosisAdhdSubHeader,
                    description: languageTokens.diagnosisAdhdDescription,
                    bulletPoints: [],
                    skills: [],
                },
                {
                    date: '',
                    header: languageTokens.diagnosisAspergersHeader,
                    subHeader: languageTokens.diagnosisAspergersSubHeader,
                    description: languageTokens.diagnosisAspergersDescription,
                    bulletPoints: [],
                    skills: [],
                },
                // {
                //     date: '10.2020 - 10.2021',
                //     header: languageTokens.depressionHeader,
                //     subHeader: languageTokens.depressionSubHeader,
                //     description: languageTokens.depressionDescription,
                //     bulletPoints: [],
                //     skills: [],
                // },
            ]
        },
        {
            year: "2020",
            careerProjects: [
                {
                    date: '06.2019 - 08.2020',
                    header: languageTokens.memoreHeader,
                    subHeader: languageTokens.memoreSubHeader,
                    description: languageTokens.memoreDescription,
                    bulletPoints: [
                        languageTokens.memoreBulletPoint1,
                        languageTokens.memoreBulletPoint2,
                        languageTokens.memoreBulletPoint3,
                        languageTokens.memoreBulletPoint4,
                        languageTokens.memoreBulletPoint5,
                        languageTokens.memoreBulletPoint6,
                        languageTokens.memoreBulletPoint7,
                        languageTokens.memoreBulletPoint8,
                    ],
                    skills: [
                        languageTokens.cSharp,
                        languageTokens.unity3D,
                        languageTokens.nUnit,
                        languageTokens.nuget,
                        languageTokens.dotNet,
                        languageTokens.azure,
                        languageTokens.githubCiCd,
                        languageTokens.scrum,
                        languageTokens.jira,
                        languageTokens.confluence,
                        languageTokens.motionTracking,
                        languageTokens.jenkins,
                    ],
                },
                {
                    date: '2016 - 2020',
                    header: languageTokens.bachelorFinishHeader,
                    subHeader: languageTokens.bachelorFinishSubHeader,
                    description: languageTokens.bachelorFinishDescription,
                    bulletPoints: [],
                    skills: [
                        languageTokens.ruby,
                        languageTokens.java,
                        languageTokens.prolog,
                        languageTokens.c,
                        languageTokens.assembler,
                        languageTokens.typescript,
                        languageTokens.cSharp,
                        languageTokens.databases,
                        languageTokens.broker,
                        languageTokens.automation,
                        languageTokens.unity3D,
                        languageTokens.algorithms,
                        languageTokens.softwareDevelopment,
                        languageTokens.softwareArchitecture,
                        languageTokens.distributedSystems,
                        languageTokens.itSecurity,
                        languageTokens.vr,
                        languageTokens.machineLearning,
                    ],
                },
                {
                    date: '05.2019 - 05.2020',
                    header: languageTokens.bachelorThesisHeader,
                    subHeader: languageTokens.bachelorThesisSubHeader,
                    description: languageTokens.bachelorThesisDescription,
                    bulletPoints: [
                        languageTokens.bachelorThesisBulletPoint1,
                        languageTokens.bachelorThesisBulletPoint2,
                        languageTokens.bachelorThesisBulletPoint3,
                        languageTokens.bachelorThesisBulletPoint4,
                    ],
                    skills: [
                        languageTokens.unity3D,
                        languageTokens.vr,
                        languageTokens.excel,
                        languageTokens.lateX,
                    ],
                },
            ]
        },
        {
            year: "2019",
            careerProjects: [
                {
                    date: '09.2018 - 05.2019',
                    header: languageTokens.memoreCareHeader,
                    subHeader: languageTokens.memoreCareSubHeader,
                    description: languageTokens.memoreCareDescription,
                    bulletPoints: [
                        languageTokens.memoreCareBulletPoint1,
                        languageTokens.memoreCareBulletPoint2,
                        languageTokens.memoreCareBulletPoint3,
                        languageTokens.memoreCareBulletPoint4,
                        languageTokens.memoreCareBulletPoint5,
                    ],
                    skills: [
                        languageTokens.cSharp,
                        languageTokens.aspNetCore,
                        languageTokens.entityFramework,
                        languageTokens.mySQL,
                        languageTokens.react,
                        languageTokens.azure,
                        languageTokens.jira,
                        languageTokens.swagger,
                    ],
                },
            ]
        },
        {
            year: "2018",
            careerProjects: [
                {
                    date: '02.2018 - 09.2018',
                    header: languageTokens.magentoHeader,
                    subHeader: languageTokens.magentoSubHeader,
                    description: languageTokens.magentoDescription,
                    bulletPoints: [
                        languageTokens.magentoBulletPoint1,
                        languageTokens.magentoBulletPoint2,
                        languageTokens.magentoBulletPoint3,
                    ],
                    skills: [
                        languageTokens.linux,
                        languageTokens.apache,
                        languageTokens.mySQL,
                        languageTokens.php,
                        languageTokens.magento,
                        languageTokens.javascript,
                        languageTokens.jQuery,
                    ],
                },
                {
                    date: '07.2017 - 01.2018',
                    header: languageTokens.synonymServiceHeader,
                    subHeader: languageTokens.synonymServiceSubHeader,
                    description: languageTokens.synonymServiceDescription,
                    bulletPoints: [
                        languageTokens.synonymServiceBulletPoint1,
                        languageTokens.synonymServiceBulletPoint2,
                    ],
                    skills: [
                        languageTokens.php,
                        languageTokens.symfony,
                        languageTokens.javascript,
                        languageTokens.jQuery,
                    ],
                },

            ]
        },
        {
            year: "2016",
            careerProjects: [
                {
                    date: '',
                    header: languageTokens.bachelorStartHeader,
                    subHeader: languageTokens.bachelorStartSubHeader,
                    description: languageTokens.bachelorStartDescription,
                    bulletPoints: [],
                    skills: [],
                },
            ]
        },
        {
            year: "2015",
            careerProjects: [
                {
                    date: '06.2015 - 10.2015',
                    header: languageTokens.racingHeader,
                    subHeader: languageTokens.racingSubHeader,
                    description: languageTokens.racingDescription,
                    bulletPoints: [
                        languageTokens.racingBulletPoint1,
                        languageTokens.racingBulletPoint2,
                        languageTokens.racingBulletPoint3,
                    ],
                    skills: [
                        languageTokens.unity3D,
                        languageTokens.cSharp,
                        languageTokens.android,
                        languageTokens.iOs,
                        languageTokens.git,
                    ],
                },
                {
                    date: '02.2015 - 05.2015',
                    header: languageTokens.puzzleHeader,
                    subHeader: languageTokens.puzzleSubHeader,
                    description: languageTokens.puzzleDescription,
                    bulletPoints: [
                        languageTokens.puzzleBulletPoint1,
                        languageTokens.puzzleBulletPoint2,
                        languageTokens.puzzleBulletPoint3,
                    ],
                    skills: [
                        languageTokens.unity3D,
                        languageTokens.cSharp,
                        languageTokens.android,
                        languageTokens.iOs,
                        languageTokens.git,
                        languageTokens.sensorTower,
                        languageTokens.appAnnie,
                        languageTokens.aso,
                    ],
                },
                {
                    date: '06.2014 - 01.2015',
                    header: languageTokens.jumpnRunHeader,
                    subHeader: languageTokens.jumpnRunSubHeader,
                    description: languageTokens.jumpnRunDescription,
                    bulletPoints: [
                        languageTokens.jumpnRunBulletPoint1,
                        languageTokens.jumpnRunBulletPoint2,
                        languageTokens.jumpnRunBulletPoint3,
                        languageTokens.jumpnRunBulletPoint4,
                    ],
                    skills: [
                        languageTokens.unity3D,
                        languageTokens.cSharp,
                        languageTokens.android,
                        languageTokens.git,
                        languageTokens.sensorTower,
                        languageTokens.appAnnie,
                        languageTokens.aso,
                    ],
                },
            ]
        },
        {
            year: "2014",
            careerProjects: [
                {
                    date: '2012 - 2014',
                    header: languageTokens.saeFinishHeader,
                    subHeader: languageTokens.saeFinishSubHeader,
                    description: languageTokens.saeFinishDescription,
                    bulletPoints: [],
                    skills: [
                        languageTokens.autodeskMaya,
                        languageTokens.zBrush,
                        languageTokens.mudbox,
                        languageTokens.adobePhotoshop,
                        languageTokens.adobeIllustrator,
                        languageTokens.rigging,
                        languageTokens.threeDAnimation,
                        languageTokens.unity3D,
                        languageTokens.substancePainter,
                        languageTokens.nDo,
                        languageTokens.dDo,
                    ],
                },
                {
                    date: '06.2013 - 01.2014',
                    header: languageTokens.brawlerHeader,
                    subHeader: languageTokens.brawlerSubHeader,
                    description: languageTokens.brawlerDescription,
                    bulletPoints: [
                        languageTokens.bookingBulletPoint1,
                        languageTokens.brawlerBulletPoint2,
                        languageTokens.brawlerBulletPoint3,
                    ],
                    skills: [
                        languageTokens.unity3D,
                        languageTokens.autodeskMaya,
                        languageTokens.adobePhotoshop,
                    ],
                },
                {
                    date: '2012',
                    header: languageTokens.saeStartHeader,
                    subHeader: languageTokens.saeStartSubHeader,
                    description: languageTokens.saeStartDescription,
                    bulletPoints: [],
                    skills: [],
                },
            ]
        },
        {
            year: "2012",
            careerProjects: [
                {
                    date: '2012',
                    header: languageTokens.abiturHeader,
                    subHeader: 'Gymnasium Sylt',
                    description: '',
                    bulletPoints: [],
                    skills: [],
                },
            ]
        },
        {
            year: languageTokens.start,
            careerProjects: []
        }
    ];
}
